export default "__VITE_ASSET__D93SbW$A__"